<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      icon="mdi-file-document-edit-outline"
      :breadcrumbs="breadcrumbs"
    ></vuse-section-definition>
       
           <v-row class="mx-1 mt-3">
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-text-field
          background-color="#EDF2F7"
          filled
         v-model="post.name"
          label="Tên bài viết"
          @input="debounceInputName"
        ></v-text-field>
      </v-col>
             <v-col class="mx-3" cols="3.5" sm="3.5">
               <v-text-field
                   background-color="#EDF2F7"
                   filled
                   v-model="post.slug"
                   label="Slug"
                   @input="debounceInputSlug"
               ></v-text-field>
             </v-col>               <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-select
          background-color="#EDF2F7"
          filled
          v-model="post.type"
          :items="this.type"
          item-text="text"
          item-value="value"
          label="Loại tin"
          @change="getItem"
        ></v-select>
      </v-col>
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-select
          background-color="#EDF2F7"
          filled
          v-model="post.type_post"
          :items="this.type_post"
          item-text="text"
          item-value="value"
          label="Loại thời gian"
          @change="getItem"
        ></v-select>
      </v-col>
       </v-row>
       <v-row class="mx-1">
      <v-menu
              class="float-left"
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  filled
                  class="mr-3 float-left"
                  v-model="dateStart"
                  label="Thời gian bắt đầu"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateStart"
                @input="menu1 = false"
                @change="getItem"
              ></v-date-picker>
            </v-menu>
            <v-menu
              class="float-left"
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  filled
                  class="mr-3 float-left"
                  v-model="dateEnd"
                  label="Thời gian kết thúc"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateEnd"
                @input="menu2 = false"
                @change="getItem"
              ></v-date-picker>
            </v-menu>
            
<!--      <v-col cols="1.5">-->
<!--        <v-btn color="primary" @click="getItem"> Search </v-btn>-->
<!--      </v-col>-->
      <v-col align="right">
        <v-btn color="primary" align="right" @click="addNews" v-if="hasPermissions('Create post')">
          Thêm bài viết
        </v-btn>
      </v-col>
      </v-row>
  
    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="newSearches"
            :page.sync="page_number"
            :items-per-page="itemsPerPage"
              class="elevation-1"
            @page-count="pageCount = $event"
          >
            <template v-slot:item.created_at="{ item }">
                <span>{{ formatDate(item.created_at) }}</span>
            </template>
          
            <template v-slot:item.photo_url_path="{ item }">
              <img width="80" :src=" item.photo_url_path" />
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)" v-if="hasPermissions('Update post')">
                mdi-pencil
              </v-icon>
               <v-icon small @click="deleteItem(item.id)" v-if="hasPermissions('Delete post')">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { DELETE_NEWS, GET_LIST_NEWS_SEARCH } from "@/store/modules/news";
import { mapGetters } from "vuex";
import {debounce} from "debounce";

export default {
  data() {
    return {
      current_page: 1,
      page_number: 1,
      pageCount: 0,
      itemsPerPage: 10,
      dateStart: "",
      dateEnd: "",
      menu: false,
      menu1: false,
      menu2: false,
      page: "Quản lý bài viết",
      type_post : [
        { text : "Tất cả", value : -1},
        { text : "Thời gian tạo", value : 1},
        {
          text : " Thời gian update", value : 2
        }

      ],
            type : [
        { text : "Tất cả", value : -1},
        { text : "Tin tức", value : 1},
        {
          text : " Video", value : 2
        }

      ],
      post : [{type_post : null}, {time_start : null}, {time_end : null}, {contents : null}, { name : null}, {type : null}, {slug : null}],
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý bài viết",
          disabled: true,
        },
      ],
      headers: [
        { text: "STT", value: "id", align: "start" },
        { text: "Ảnh bìa", sortable: false, value: "photo_url_path" },
        { text: "Tên", value: "name" },
        { text: "Thời gian", value: "created_at" },
        { text: "Lượt xem", value: "viewed" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters({
      news: "news",
      newSearches: 'newSearches',

    }),
  },
  async created() {
    this.page_number = parseInt(this.$route.query.page_current) || 1
    this.post.type_post = parseInt(this.$route.query.type_post) || ''
    this.post.type = parseInt(this.$route.query.type) || ''
    this.dateStart = this.$route.query.time_start
    this.dateEnd = this.$route.query.time_end
    this.post.name = this.$route.query.name
    this.post.slug = this.$route.query.slug
   this.params();
  },
  methods: {
    params(){
      let params = {
        type_post : this.post.type_post!= "-1" ? this.post.type_post : 1,
        time_start : this.dateStart,
        time_end : this.dateEnd,
        contents : this.post.contents,
        name : this.post.name,
        slug : this.post.slug,
        type : this.post.type!= "-1" ? this.post.type : null
      };
      this.$store.dispatch(GET_LIST_NEWS_SEARCH, params);
    },
    replacePost() {
      this.$router.replace({
        query: {
          type_post : parseInt(this.post.type_post!= "-1" ? this.post.type_post : 1),
          time_start : this.dateStart,
          time_end : this.dateEnd,
          contents : this.post.contents,
          name : this.post.name,
          slug : this.post.slug,
          type : parseInt(this.post.type!= "-1" ? this.post.type : null),
          page_current: parseInt(this.page_number),
        }
      })
    },
    debounceInputName: debounce(function (e) {
      this.post.name = e;
      this.replacePost();
      this.params();
    }, 200),
    debounceInputSlug: debounce(function (e) {
      this.post.slug = e;
      this.replacePost();
      this.params();
    }, 200),
      getItem(){
        this.replacePost();
        this.params();
      },
      editItem(item){
        this.replacePost();
      this.$router.push({
        path:'/manage_news/manage_new/edit_news/'+item.id,
      })
    },
    addNews(){
     this.$router.push('/manage_news/manage_new/add_news')
    },
    deleteItem(id)
    {
      confirm('Bạn có chắc chắn muốn xóa không ?') &&
      this.$store.dispatch(`${DELETE_NEWS}`,id).then(data=>{
        if(data && data.status === 1) {
          this.params();
        }
      })
    },
    formatDate(date) {
      if (!date) return null;
      let newDate = new Date(date);
      const [year, month, day] = [
        newDate.getFullYear(),
        newDate.getMonth() + 1,
        newDate.getDate(),
      ];
      let day_format = day > 9 ? day : `0${day}`;
      let month_format = month > 9 ? month : `0${month}`;

      return `${day_format}/${month_format}/${year}`;
    },
  },
};
</script>
